window.MetaPixel = {
  trackOnce(eventName, eventKey, params = {}) {
    if (!window.fbq) return;

    const key = `meta_${eventKey}_${eventName?.toLowerCase()}`;

    if (localStorage.getItem(key)) return;

    fbq("track", eventName, params);
    localStorage.setItem(key, "1");
  },
};
